<div class="rich-text-editor-container">
  @if (Editor) {
    <ckeditor [editor]="Editor" [config]="editorConfig" [(ngModel)]="value" (ngModelChange)="onModelChange($event)"
      (ready)="onReady($event)" (focus)="onFocus()">
    </ckeditor>
  }
</div>
